/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator/services';
import { apiConfig } from '@/config/apiConfig';
import { IS_ORG_NAME_EXIST } from '../../api/graphql';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IIsOrgNameExistMethods extends IPluginMethodMap {
  isOrgNameExist(args: { name: string }): Promise<{ isOrgNameExist: boolean }>;
}

export class IsOrgNameExistService implements IAgentPlugin {
  readonly methods: IIsOrgNameExistMethods;

  constructor() {
    this.methods = {
      isOrgNameExist: this.isOrgNameExist.bind(this),
    };
  }

  async isOrgNameExist(args: { name: string }): Promise<{ isOrgNameExist: boolean }> {
    const storageService = StorageModule.getInstance();

    const localToken = storageService.get('myProfile', 'local');
    const sessionToken = storageService.get('myProfile', 'session');
    const vuid = localToken?.vuid ?? sessionToken?.vuid;

    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }

      const client = gql.getClient();
      if (client) {
        const res = await client.query(IS_ORG_NAME_EXIST, {
          orgName: args.name,
        });
        console.log('Asir pu Response from isOrgNameExist query:', res); 

        const isOrgNameExist = res?.data?.isOrgNameExist ?? false;

        return { isOrgNameExist };
      }
    } catch (err: any) {
              console.log('Asir pu Response from isOrgNameExist query:', args); 

      console.log('Error checking org name existence:', err);
    }

    return { isOrgNameExist: false };
  }
}
